// extracted by mini-css-extract-plugin
export default {"main":"styles_main__RDA7K","container":"styles_container__bKV91","error":"styles_error__FW6ML","submit":"styles_submit__BmHtw","no_account":"styles_no_account__5YzuE"};